import React, { useEffect } from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledDatePicker from "../../components/Backoffice/ControlledDatePicker";
import ControlledRadio from "../../components/Backoffice/ControlledRadio";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";

const EditSampleDetailsForm = ({
  control,
  errors,
  setValue,
  variantField,
  variant,
  editSampleDetailsWatch,
}) => {
  const currentDate = new Date();

  useEffect(() => {
  if (editSampleDetailsWatch("manufacturingDatePresent") === "No") {
    setValue("manufacturingDate", null);
  }

  if (editSampleDetailsWatch("expiryDatePresent") === "No") {
    setValue("expiryDate", null);
  }

  if (editSampleDetailsWatch("brandNamePresent") === "No") {
    setValue("brandName", "");
  }

  if (editSampleDetailsWatch("manufacturerNamePresent") === "No") {
    setValue("manufacturersName", "");
  }

  if (editSampleDetailsWatch("lotNumberPresent") === "No") {
    setValue("lotNumber", "");
  }

  if (editSampleDetailsWatch("manufacturerPlantAddressPresent") === "No") {
    setValue("manufacturingPlantAddress", "");
  }

  if (editSampleDetailsWatch("fssaiLicenseNumberPresent") === "No") {
    setValue("fssaiLicenseNumber", "");
  }

  if (editSampleDetailsWatch("countryOfOriginPresent") === "No") {
    setValue("countryOfOrigin", "");
  }

  if (editSampleDetailsWatch("sampleClaim") === "No") {
    setValue("sampleClaimDescription", "");
  }
}, [
  editSampleDetailsWatch("manufacturingDatePresent"),
  editSampleDetailsWatch("expiryDatePresent"),
  editSampleDetailsWatch("brandNamePresent"),
  editSampleDetailsWatch("manufacturerNamePresent"),
  editSampleDetailsWatch("lotNumberPresent"),
  editSampleDetailsWatch("manufacturerPlantAddressPresent"),
  editSampleDetailsWatch("fssaiLicenseNumberPresent"),
  editSampleDetailsWatch("countryOfOriginPresent"),
  editSampleDetailsWatch("sampleClaim"),
]);

  return (
    <Form colon={false}>
      {/* <> */}
      {variantField.includes("manufacturingDatePresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="manufacturingDatePresent"
              label="Manufacturing Date Present"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("manufacturingDate") &&
        editSampleDetailsWatch("manufacturingDatePresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledDatePicker
                required
                control={control}
                format="DD-MM-YYYY"
                showTime={true}
                name="manufacturingDate"
                label="Manufacturing Date"
                errors={errors}
                maximum={new Date(currentDate.getTime())}
              />
            </Col>
          </Row>
        )}
      {variantField.includes("expiryDatePresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="expiryDatePresent"
              label="Expiry Date Present?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("expiryDate") &&
        editSampleDetailsWatch("expiryDatePresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledDatePicker
                required
                control={control}
                format="DD-MM-YYYY"
                showTime={true}
                name="expiryDate"
                label="Expiry Date"
                errors={errors}
                minimum={new Date(currentDate.getTime())}
              />
            </Col>
          </Row>
        )}
      {variantField.includes("brandNamePresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="brandNamePresent"
              label="Brand Name Present?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("brandName") &&
        editSampleDetailsWatch("brandNamePresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="brandName"
                label="Brand Name"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      {variantField.includes("manufacturerNamePresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="manufacturerNamePresent"
              label="Manufacture Name Present?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("manufacturersName") &&
        editSampleDetailsWatch("manufacturerNamePresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="manufacturersName"
                label="Manufacturers Name"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      {/* </> */}
      {variantField.includes("lotNumberPresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="lotNumberPresent"
              label="Lot Number Present?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("lotNumber") &&
        editSampleDetailsWatch("lotNumberPresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="lotNumber"
                label="Lot Number"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      {variantField.includes("packagingType") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledSelect
              required
              control={control}
              name="packagingType"
              label="Packaging Type "
              options={[
                { label: "Refrigerated (Gel Pack / Dry Ice)", value: "Refrigerated (Gel Pack / Dry Ice)" },
                { label: "Non-Refrigerated (No cooling material)", value: "Non-Refrigerated (No cooling material)" },
              ]}
              errors={errors}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("samplePackedIn") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledSelect
              required
              control={control}
              name="samplePackedIn"
              label="Sample Packed In"
              options={[
                { label: "General Packing", value: "General Packing" },
                { label: "Special Packing", value: "Special Packing" },
              ]}
              errors={errors}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("fssaiLogoPresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="fssaiLogoPresent"
              label="Does the sample have FSSAI logo ?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("vegSymbolPresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="vegSymbolPresent"
              label="Does the sample have Veg/Non-veg symbol ?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("jaivikBharatSymbolPresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="jaivikBharatSymbolPresent"
              label="Does the sample have Jaivik Bharat symbol ?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("qrCodeId") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledInput
              required
              control={control}
              name="qrCodeId"
              label="QR Code Id"
              errors={errors}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("sampleSealNo") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledInput
              required
              control={control}
              name="sampleSealNo"
              label="Sample Seal No"
              errors={errors}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("manufacturerPlantAddressPresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="manufacturerPlantAddressPresent"
              label="Manufacturing Plant Address Present?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("manufacturingPlantAddress") &&
        editSampleDetailsWatch("manufacturerPlantAddressPresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required={variant === "Loose" ? false : true}
                control={control}
                name="manufacturingPlantAddress"
                label="Manufacturing Plant Address"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      {variantField.includes("fssaiLicenseNumberPresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="fssaiLicenseNumberPresent"
              label="FSSAI License Number Present?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("fssaiLicenseNumber") &&
        editSampleDetailsWatch("fssaiLicenseNumberPresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="fssaiLicenseNumber"
                label="FSSAI License Number"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      {variantField.includes("countryOfOriginPresent") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              required
              control={control}
              name="countryOfOriginPresent"
              label="Country Of Origin Present"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("countryOfOrigin") &&
        editSampleDetailsWatch("countryOfOriginPresent") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                required
                control={control}
                name="countryOfOrigin"
                label="Country of Origin"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      {variantField.includes("sampleClaim") && (
        <Row gutter={24}>
          <Col span={24}>
            <ControlledRadio
              control={control}
              name="sampleClaim"
              label="Any claim made on sample?"
              errors={errors}
              options={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
            />
          </Col>
        </Row>
      )}
      {variantField.includes("sampleClaimDescription") &&
        editSampleDetailsWatch("sampleClaim") === "Yes" && (
          <Row gutter={24}>
            <Col span={24}>
              <ControlledInput
                control={control}
                name="sampleClaimDescription"
                label="Sample Claim Description"
                errors={errors}
              />
            </Col>
          </Row>
        )}
    </Form>
  );
};

export default EditSampleDetailsForm;
